/* -----------------Globals--------------- */
import { Image } from "react-native";
import { List } from "react-native-paper";

/* -----------------Child components--------------- */
import Box from "@memorang/ui/src/components/Box";
import Loader from "@memorang/ui/src/components/Loader";

import { events } from "@constants/tracking";
import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppTheme } from "@hooks/useAppTheme";
/* -----------------Third parties--------------- */
import useExams from "@hooks/useExams";
import type { Category } from "@memorang/types/src/exams";
import { trackCustomEvent } from "analytics";

export const ChooseCategoryContainer = ({
	handleNext,
}: { handleNext: (param?: string) => void }) => {
	const theme = useAppTheme();

	const { categories } = useExams();

	if (!categories?.length) {
		return <Loader />;
	}
	const ListCategory = ({ categories }: { categories: Category[] }) => {
		return (
			<Box justifyContent="center" gap={16} paddingTop={24}>
				{categories.map(({ icon, name, id }) => {
					return (
						<List.Item
							key={id}
							onPress={() => {
								trackCustomEvent({
									eventName: events.categorySelected,
									category: name,
								});
								handleNext(name);
							}}
							style={{
								paddingHorizontal: 16,
							}}
							title={name}
							left={() => (
								<Image
									source={{
										uri: icon,
									}}
									style={{
										width: 32,
										height: 32,
										tintColor: theme.colors.onSurface,
									}}
								/>
							)}
							right={(p) => (
								<List.Icon
									{...p}
									icon={(props) => <Icon {...props} name="chevron-right" />}
								/>
							)}
						/>
					);
				})}
			</Box>
		);
	};
	return <ListCategory categories={categories} />;
};
